import { MessageSquareText, Phone } from "lucide-react";
import TextUs, { useSmsMessage } from "@/components/TextUs";
import { PHONE_DISPLAY, TEL_HREF, whatsappHref } from "@/lib/contact";

export function WhatsAppIcon({ className = "w-4 h-4" }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.42.25-.7.25-1.29.17-1.42-.07-.12-.27-.2-.57-.35M12.05 21.5h-.01a9.4 9.4 0 0 1-4.8-1.32l-.34-.2-3.57.94.95-3.48-.22-.36a9.4 9.4 0 0 1-1.44-5.02c0-5.2 4.24-9.43 9.44-9.43a9.37 9.37 0 0 1 6.67 2.77 9.37 9.37 0 0 1 2.76 6.67c0 5.2-4.24 9.43-9.44 9.43m8.03-17.46A11.3 11.3 0 0 0 12.05.7C5.79.7.7 5.79.7 12.05c0 2 .52 3.95 1.52 5.67L.6 23.3l5.72-1.5a11.3 11.3 0 0 0 5.72 1.46h.01c6.26 0 11.35-5.09 11.35-11.35 0-3.03-1.18-5.88-3.32-8.03" />
    </svg>
  );
}

type Variant = "hero" | "solid";

/**
 * Text Maria (sms on phones, copy-the-number on computers), WhatsApp and Call.
 * Clicks are tracked by the document listener (sms_click / whatsapp_click / phone_click).
 */
export default function ContactButtons({
  variant = "solid",
  stacked = false,
  showCall = true,
  className = "",
}: {
  variant?: Variant;
  /** One button per row (narrow cards). */
  stacked?: boolean;
  showCall?: boolean;
  className?: string;
}) {
  const msg = useSmsMessage();
  const primary = variant === "hero" ? "btn-primary-hero" : "btn-primary";
  const outline = variant === "hero" ? "btn-outline-hero" : "btn-outline";
  const base = "rounded-sm inline-flex items-center justify-center gap-2 text-center w-full";
  const width = stacked ? "" : "sm:w-auto";
  return (
    <div className={`flex ${stacked ? "flex-col" : "flex-col sm:flex-row sm:flex-wrap"} gap-3 ${stacked ? "" : "justify-center"} ${className}`}>
      <TextUs
        primary
        ariaLabel="Text Maria at Atlanta Luxury Sprinters"
        className={`${primary} ${base} ${width}`}
        desktopClassName={`${primary} ${base} ${width}`}
      >
        <MessageSquareText className="w-4 h-4" aria-hidden="true" /> Text Maria
      </TextUs>
      <a
        href={whatsappHref(msg)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp Maria at Atlanta Luxury Sprinters"
        className={`${outline} ${base} ${width}`}
      >
        <WhatsAppIcon /> WhatsApp
      </a>
      {showCall && (
        <a href={TEL_HREF} className={`${outline} ${base} ${width}`}>
          <Phone className="w-4 h-4" aria-hidden="true" /> Call {PHONE_DISPLAY}
        </a>
      )}
    </div>
  );
}
